<template>
  <div :class="cssClass">
    <img v-if="src" :src="src" alt="" />
    <i v-else class="fas fa-user"></i>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: false
    }
  },
  computed: {
    cssClass() {
      return {
        'c-image--avatar': true
      };
    }
  }
};
</script>
